import { useAtom } from "jotai";
import { useEffect } from "react";
import { DEFAULT_CURSOR_SIZE } from "../consts";
import {
  currentSessionIdAtom,
  userLocationsAtom,
  videoStreamsAtom,
} from "../jotai/atoms";
import { extractUserId } from "../utils/session";
import { AgoraRoom } from "./AgoraService";

const HIGH = 0;
const LOW = 1;
const dualEnable = new WeakSet<AgoraRoom>();

export function useAgoraDualStream(room: AgoraRoom | null) {
  const [videos] = useAtom(videoStreamsAtom);
  const [locations] = useAtom(userLocationsAtom);
  const [currentSessionId] = useAtom(currentSessionIdAtom);

  useEffect(() => {
    if (!room || dualEnable.has(room)) return;

    // enableDualStream() could raise error when it was previously enabled
    // so we kept a global 'dualEnable' state to remember it
    try {
      room.client.enableDualStream();
      room.client.setLowStreamParameter({
        width: 2 * DEFAULT_CURSOR_SIZE,
        height: 2 * DEFAULT_CURSOR_SIZE,
        framerate: 15,
        bitrate: 200,
      });
      dualEnable.add(room);
    } catch (e) {
      // enableDualStream() could raise error when it was previously enabled
      console.error(e);
    }
  }, [room]);

  useEffect(() => {
    if (!room) return;

    const docked = new Set(Object.entries(locations).map(([uid]) => uid));

    for (const sid in videos) {
      const uid = extractUserId(sid);
      if (!uid || sid === currentSessionId) continue;

      const q = docked.has(uid) ? HIGH : LOW;
      room.client.setRemoteVideoStreamType(sid, q);
    }
  }, [locations, videos, currentSessionId, room]);
}
